import { EnvironmentVariables } from '../EnvironmentVariables';

interface OpenSiteInJBPProps {
  mpan: string;
  contractType: string;
}

const contractTypeToServiceLine: Record<string, string> = {
  '8': 'HH',
  '2': 'NHH',
  '4': 'SUBMETER',
  '100': 'DNO',
  '101': 'BNO',
  '111': 'MSS',
  '112': 'MSA'
};

export const OpenSiteInJBP = ({ mpan, contractType }: OpenSiteInJBPProps) => {
  const handleClick = () => {
    const serviceLine = contractTypeToServiceLine[contractType];
    if (!serviceLine) return;
    window.open(`${EnvironmentVariables.JbpUrl}/site/${mpan}/${serviceLine}`, '_blank');
  };

  return (
    <div className="pb-2 flex flex-row cursor-pointer" onClick={handleClick}>
      <div className="text-interactive-coral hover:text-interactive-coral-db-70 text-sm">Open Site in Job Booking Portal</div>
      <img src="/externalLinkButtonActive.svg" alt="external-link" className="pl-1 w-4 h-4" />
    </div>
  );
};
